
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <p>{`The Grid components consists of 3 different components: `}<inlineCode parentName="p">{`<Grid>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<Row>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<Col>`}</inlineCode>{`.
By default, it has a max content width of 1320px and gutters of 24px.`}</p>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Grid>
  <Row align="center">
    <Col size={3}>Size: 3</Col>
    <Col size={7}>Size: 7</Col>
  </Row>
  <Row align="flex-start">
    <Col size={2}>Size: 2</Col>
    <Col size={5}>Size: 5</Col>
  </Row>
</Grid>
`}</code></pre>
    <h3 {...{
      "id": "props---grid"
    }}>{`Props - Grid`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
    </table>
    <h1 {...{
      "id": "row"
    }}>{`Row`}</h1>
    <p>{`Groups a number of columns and can align them.`}</p>
    <p>{`A row groups a number of columns and can align them`}</p>
    <h3 {...{
      "id": "props---row"
    }}>{`Props - Row`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`align`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"start" ｜ "end" ｜ "center" ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`start`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "col"
    }}>{`Col`}</h1>
    <p>{`A col component has a size to define how many columns it spans over.`}</p>
    <p>{`The size prop can be used in two different ways:`}</p>
    <ul>
      <li parentName="ul">{`Passing a number will set the column size for the `}<inlineCode parentName="li">{`fromL`}</inlineCode>{` breakpoint while it defaults to full width for smaller viewports.`}</li>
      <li parentName="ul">{`Passing an object with sizes for the available breakpoints:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`default`}</inlineCode>{`: refers to viewports from `}<strong parentName="li">{`0 - 480px`}</strong></li>
          <li parentName="ul"><inlineCode parentName="li">{`theme.breakpoints.fromM`}</inlineCode>{`: refers to viewports from `}<strong parentName="li">{`480 - 1024px`}</strong></li>
          <li parentName="ul"><inlineCode parentName="li">{`theme.breakpoints.fromL`}</inlineCode>{`: refers to viewports over `}<strong parentName="li">{`1024px`}</strong></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "props---col"
    }}>{`Props - Col`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A JSX node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`node`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Size of column`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`union(object,number)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ default: 4, '@media (min-width: 1024px)': 12 }`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h1 {...{
      "id": "debuggrid"
    }}>{`DebugGrid`}</h1>
    <p>{`We also provide a debugging component that displays a fixed grid overlay. You can use it by importing it in development:`}</p>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<DebugGrid />
`}</code></pre>
    <h3 {...{
      "id": "props---debuggrid"
    }}>{`Props - DebugGrid`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`storybook`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;